<template>
  <div class="lead">
    <div class="lead__wrapper">
      <div class="lead__row">
        <app-form-group label="Advertising source">
          <app-select
            @input="onInputAdvertisingSource"
            v-model="form.adv_source"
            :options="advertising_source_options"
            placeholder="Advertising source"
          />
        </app-form-group>
        <app-form-group label="Advertising campaign">
          <app-select
            @input="onCheckForm({ adv_source: form.adv_source.code, adv_campaign: form.adv_campaign })"
            v-model="form.adv_campaign"
            :options="advertising_campaign_options"
            :reduce="item => item.id"
            :readonly="!form.adv_source"
            placeholder="Advertising campaign"
          />
        </app-form-group>
      </div>
    </div>
  </div>
</template>

<script>
import { getLeadsAdvSources, patchLead } from '@/http'

export default {
  name: 'LeadsDetailAdvertising',
  props: {
    leadInfo: Object,
  },
  data() {
    return {
      form: {},
      advertising_source_options: [],
      advertising_campaign_options: [],
    }
  },
  validations: {
    form: {}
  },
  watch: {
    leadInfo: {
      immediate: true,
      handler(val) {
        this.form = {
          adv_source: val.adv_source?.code || null,
          adv_campaign: val.adv_campaign?.id || null,
        }
        if (val.adv_source) this.advertising_campaign_options = val.adv_source.campaigns
      }
    }
  },
  created() {
    getLeadsAdvSources().then(res => {
      this.advertising_source_options = res.data
    })
  },
  methods: {
    onCheckForm(data) {
      this.$v.form.$touch()
      if (this.$v.form.$invalid) {
        this.$notify({
          type: 'info',
          title: 'Check that the form fields are filled in correctly',
        })
      } else {
        patchLead(this.$route.params.id, data)
          .then(() => {
            this.$emit('update-info')
            this.$notify({
              type: 'success',
              title: 'Data saved',
            })
            this.$v.form.$reset()
          })
      }
    },
    onInputAdvertisingSource(e) {
      this.form.adv_campaign = null
      if (e) this.advertising_campaign_options = e.campaigns
      this.onCheckForm({adv_source: this.form.adv_source?.code || null, adv_campaign: this.form.adv_campaign})
    },
  }
}
</script>

<style scoped lang="sass">
.lead__wrapper
  max-width: 1080px

  +max-w($laptop_md)
    max-width: 100%

.lead__row
  display: grid
  gap: 10px 20px
  grid-template-columns: repeat(5, 1fr)

  +max-w($laptop_md)
    grid-template-columns: repeat(3, 1fr)
</style>
